import LayoutMaster from "components/layout/layout_master";
import ArrowClockWise from "components/view/arrow_clock_wise";
import { MaxButton, StatusMaxButton } from "components/view/button";
import {
  MuiTextFieldFrom,
  MuiTextFieldFromWithoutFormControl,
} from "components/view/text_field_from";
import { CenterProps } from "lib/all_type/center_props";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
  GetPrefixLevel,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import { GetInfoResponse } from "lib/worker/api/getinfo";
import get_chaptcha, { GetChaotchaResponse } from "lib/worker/api/get_chaptcha";
import { GetServerSideProps } from "next";
import Router, { useRouter } from "next/router";
import React from "react";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { memberActionTypes } from "../../lib/store/member/reducer";
import loginAPI from "../../lib/worker/api/login";

interface LoginPageProps extends CenterProps {
  login: Function;
  infomation: CheckWithPrefixResponse;
}

function LoginPage(props: LoginPageProps) {
  const login: Function = props.login;
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [digits, setDigits] = useState<string>("");
  const [chaptcha, setChaptcha] = useState<GetChaotchaResponse>();
  const router = useRouter();
  const { infomation } = props;
  const prefix = GetPrefixLevel(infomation);

  useEffect(() => {
    loadChaptcha();
  }, []);

  const loadChaptcha = () => {
    get_chaptcha()
      .then((json) => {
        setChaptcha(json);
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  const onSubmit = (event: any) => {
    event.preventDefault();

    setLoading(true);
    loginAPI({
      username: prefix + username,
      password: password,
      id: chaptcha?.id,
      digits: digits,
    })
      .then((json) => {
        login(json);
        setLoading(false);
        Router.push("/");
      })
      .finally(() => {
        loadChaptcha();
      })
      .catch((error) => {
        setLoading(false);
        props.alertWithMessage(error.response.data.message);
      });
  };

  const goToRegister = () => {
    router.push(`/register/${prefix}`);
  };

  const goToForgotPassword = () => {
    router.push(`/forgot_password/${prefix}`);
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เข้าสู่ระบบ คาสิโนออนไลน์",
        description:
          "ผู้ให้ บริการ สปอร์ตออนไลน์ คาสิโนออนไลน์ เต็มรูปแบบ ท่านสามารถ เล่นได้ตลอด 24 ชั่วโมง ไม่มีสะดุด สามารถสมัครสมาชิก สะดวก รวดเร็ว พร้อมกิจกรรม ลุ้นรับเครดิต",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ marginTop: 80 }}>
        <h1 className="text-center margin-bottom-20">เข้าสู่ระบบ</h1>
        <Form noValidate onSubmit={onSubmit}>
          <div className="margin-top-20">
            <MuiTextFieldFrom
              title="ชื่อผู้ใช้สำหรับเข้าเล่น"
              value={username}
              prefix={prefix}
              despication="*หากสมัครด้วยเบอร์โทรศัพท์ให้ระบุเบอร์โทรศัพท์"
              type="username"
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            ></MuiTextFieldFrom>
          </div>
          <div className="margin-top-20">
            <MuiTextFieldFrom
              title="รหัสผ่าน"
              value={password}
              type="password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            ></MuiTextFieldFrom>
          </div>
          {chaptcha && (
            <>
              <form onSubmit={onSubmit}>
                <MuiTextFieldFromWithoutFormControl
                  className="margin-top-20"
                  title="กรอกรหัสรูปภาพ"
                  value={digits}
                  type="number"
                  onChange={(e) => {
                    setDigits(e.target.value);
                  }}
                ></MuiTextFieldFromWithoutFormControl>
              </form>
              <div className="margin-top-20">
                <Form.Group>
                  <img
                    style={{
                      height: "auto",
                      width: 200,
                      backgroundColor: "white",
                      borderRadius: 10,
                    }}
                    src={chaptcha?.image}
                  ></img>
                  <div style={{ marginTop: 10 }}>
                    <ArrowClockWise
                      isLoad={false}
                      onClick={loadChaptcha}
                    ></ArrowClockWise>
                  </div>
                </Form.Group>
              </div>
            </>
          )}

          <MaxButton
            title="เข้าสู่ระบบ"
            onClick={onSubmit}
            loading={loading}
            className="margin-top-20"
            status={StatusMaxButton.submit}
          ></MaxButton>
        </Form>
        <div>
          <h2
            style={{ fontSize: 16 }}
            className="margin-top-10 select-div float-right"
            onClick={goToRegister}
          >
            สมัครสมาชิก?
          </h2>
          <h2
            style={{ fontSize: 16 }}
            className="margin-top-10 select-div float-left"
            onClick={goToForgotPassword}
          >
            ลืมรหัสผ่าน?
          </h2>
        </div>
      </div>
    </LayoutMaster>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    login: (json: GetInfoResponse) => {
      dispatch({
        type: memberActionTypes.ACTION_USER_LOGIN,
        payload: json,
      });
    },
  };
};

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
